import { useClientContext } from '@/context/client'
import { useClientForm } from '../hooks/use-client-form'
import ClientRegimeForm from '@/features/client/components/client-regime-form'
import ClientRegimeFormCPF from './client-regime-form-cpf'

export function ClientRegistrationFlow() {
  const {
    clientMode,
    mostrarCampos,
    clienteData,
    contadorData,
    bancos,
    regimeTributario,
    produtosSelecionados,
    customComissao,
    comissaoEscrita,
    senhaProprietario,
    bancoData,
    possui,
    concordo,
    isClienteCriado,
    isMinutaEnviada,
    setShowEditarPopup,
    setShowAssinarPopup
  } = useClientContext()

  const { createStatusClient, handleRegimeFormSubmit, handleRegimeFormSubmitCPF, handleAssinarContrato } = useClientForm()

  if (!mostrarCampos || !clientMode) return null

  const handleAssinarContratoADistancia = () => {
    setShowAssinarPopup(true)
  }

  if (clientMode === 'existing-owner') {
    return (
      <ClientRegimeFormCPF
        clientData={clienteData}
        contadorData={contadorData}
        bancos={bancos}
        initialData={{
          regimeTributario,
          produtosSelecionados,
          comissao: customComissao,
          comissaoEscrita,
          banco: bancoData.banco,
          agencia: bancoData.agencia,
          conta: bancoData.conta,
          concordo
        }}
        onSubmit={handleRegimeFormSubmitCPF}
        isClienteCriado={isClienteCriado}
        isMinutaEnviada={isMinutaEnviada}
        createStatusClient={createStatusClient}
        onEditClick={() => setShowEditarPopup(true)}
        onAssinarContrato={handleAssinarContrato}
        onAssinarContratoADistancia={handleAssinarContratoADistancia}
      />
    )
  }

  return (
    <ClientRegimeForm
      clientData={clienteData}
      contadorData={contadorData}
      bancos={bancos}
      initialData={{
        regimeTributario,
        produtosSelecionados,
        comissao: customComissao,
        comissaoEscrita,
        senha: senhaProprietario,
        banco: bancoData.banco,
        agencia: bancoData.agencia,
        conta: bancoData.conta,
        possui,
        concordo
      }}
      onSubmit={handleRegimeFormSubmit}
      isClienteCriado={isClienteCriado}
      isMinutaEnviada={isMinutaEnviada}
      createStatusClient={createStatusClient}
      onEditClick={() => setShowEditarPopup(true)}
      onAssinarContrato={handleAssinarContrato}
      onAssinarContratoADistancia={handleAssinarContratoADistancia}
    />
  )
}
